import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RestResponse } from '../../models/restResponse.mode';
import { Group } from '../../models/group.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class GroupService {
    
  private readonly baseUrl = `${environment.base_url}/groups`;

  constructor(private http: HttpClient) {}

  getAll(
    description: string,
    active: boolean | null,
    paginate: boolean,
    page: number | null,
    sectorId?: number | null
  ): Observable<RestResponse<Group[]>> {
    const d = encodeURIComponent(description ?? '');
    let url = `${this.baseUrl}/list?description=${d}&active=${active}&page=${page}&paginate=${paginate}`;
    if (sectorId != null && sectorId !== undefined) {
      url += `&sectorId=${sectorId}`;
    }
    return this.http.get<RestResponse<Group[]>>(url);
  }

  getById(id: number): Observable<RestResponse<Group>> {
    return this.http.get<RestResponse<Group>>(`${this.baseUrl}/find/${id}`);
  }

  create(group: Partial<Group>): Observable<Group> {
      return this.http.post<Group>(`${this.baseUrl}/save`, group);
  }

  update(id: number, group: Partial<Group>): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}/update/${id}`, group);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

}
